import { i18n as _i18n } from "@lingui/core";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const InfoOutlineIcon = () => /*#__PURE__*/_jsxs("svg", {
  className: "unmapped-lp-notification__icon",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "10",
    cy: "10",
    r: "9.25",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "10",
    cy: "5.85",
    r: "1.2",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("rect", {
    x: "8.95",
    y: "8",
    width: "2.1",
    height: "6.6",
    rx: "1.05",
    fill: "currentColor"
  })]
});
const CarleadUnmappedLpRedesign = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("h1", {
    className: "carlead-creation-form__title unmapped-lp-title",
    children: _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.unmappedLp.mainTitle',
      message: "Enter your car manually"
    })
  }), /*#__PURE__*/_jsxs("div", {
    className: "unmapped-lp-notification",
    role: "alert",
    children: [/*#__PURE__*/_jsx(InfoOutlineIcon, {}), /*#__PURE__*/_jsx("span", {
      className: "unmapped-lp-notification__text",
      children: _i18n._(
      /*i18n*/
      {
        id: 'carleadCreation.licensePlate.wrongLicensePlate',
        message: "We could not find a match for your license plate"
      })
    })]
  })]
});
export default CarleadUnmappedLpRedesign;